module.exports = __webpack_public_path__ + "img/malnalila-12.c32f1758.png";